<template>
    <div class="packageImages">
        <img ref="bg" src="@/assets/ewm.jpg" alt width="45%" height="45%" v-show="false" />
        <div id="qrcode" class="code" ref="qrCodeDiv" v-show="false">
            <div
                v-for="(item, index) in list"
                :key="index"
                :id="'captureId' + index"
                class="invitationCode"
                style="float:left;margin-left:20px;"
            >
                <div class="codeImgbox" ref="BoxImgContent" :id="'codeImgbox' + index"></div>
            </div>
        </div>
        <div class="circular">
            <v-progress-circular
                :rotate="360"
                @click="packageImages"
                :size="150"
                :width="4"
                :value="num"
                color="primary"
            >
                <div class="download">
                    <div></div>
                </div>
                <div class="text">
                    {{ text }}
                </div>
            </v-progress-circular>
        </div>
        <div class="prompt" v-if="text != '重新下载' && text != '点击下载' && text != '压缩完成'">
            压缩进行中....请勿退出
        </div>
        <el-button
            style="width: 7rem;margin-top:1.5rem"
            @click="cancal"
            v-if="num == '100.0' || !num"
        >
            退出
        </el-button>
    </div>
</template>
<script>
String.prototype.byteLength = function() {
    var length = 0;
    Array.from(this).map(function(char) {
        if (char.charCodeAt(0) > 255) {
            //字符编码大于255，说明是双字节字符
            length += 2;
        } else {
            length++;
        }
    });

    return length;
};
String.prototype.pxWidth = function(font) {
    var canvas =
            String.prototype.pxWidth.canvas ||
            (String.prototype.pxWidth.canvas = document.createElement("canvas")),
        context = canvas.getContext("2d");
    font && (context.font = font);
    var metrics = context.measureText(this);
    return metrics.width;
};
import util from "@/util";
import store from "@/store";
import { mapState } from "vuex";
import QRCode from "qrcodejs2";
import JSZip from "jszip";
import FileSaver from "file-saver";
export default {
    data() {
        return {
            list: [],
            stationCanvas: [],
            num: 0,
            text: "点击下载",
        };
    },
    props: {
        siteId: null,
        siteName: null,
    },
    computed: {
        ...mapState(["connectorInfo"]),
    },
    watch: {
        num: {
            handler(val) {
                if (val != "100.0") {
                    this.text = "压缩中...  " + val;
                    // console.log("加载进度" + val);
                } else {
                    // console.log("加载完成");
                    this.text = "压缩完成";
                    let that = this;
                    setTimeout(() => {
                        that.text = "重新下载";
                    }, 2000);
                    // this.text = "重新下载";
                }
            },
            deep: true,
        },
    },
    async mounted() {
        await this.getConnector();
        for (let i = 0; i < this.connectorInfo.length; i++) {
            this.list.push({
                url: "http://ecar.meisenpay.com/evc/" + this.connectorInfo[i].connector_id, // 二维码的地址
                fileName: this.connectorInfo[i].connector_id, // 设置每一个二维码的文件名
                imgSrc: "", // 生成的二维码放图片的字段
                connName: this.connectorInfo[i].name, //每把枪的名字
                siteId: this.siteId,
            });
        }
        this.list.forEach((element, index) => {
            this.$nextTick(function() {
                this.qrcode(element.url, index);
            });
        });
    },
    methods: {
        /*获取充电枪数据*/
        async getConnector() {
            let postData = {
                station_id: this.siteId,
            };
            await store.dispatch("getConnector", postData);
            console.log();
        },
        /*生成二维码*/
        qrcode(data, index) {
            let qrcode = new QRCode(this.$refs.qrCodeDiv.children[index].children[0], {
                // this.$refs.qrCodeDiv.children[index].children[0] 这个是dom选择器，选择对应的dom生成二维码
                width: 100, // 二维码的宽
                height: 100, // 二维码的高
                text: data, // 二维码地址
                colorDark: "#000", // 二维码颜色
                colorLight: "#fff", // 二维码背景色
            });
        },
        /*打包压缩*/
        packageImages() {
            this.stationCanvas = [];
            let doms = document.getElementsByClassName("invitationCode");
            if (doms.length > 0) {
                this.num = "0.0";
                this.num = "1.5";
            } else {
                util.ShowTip("该站点下未查找到充电枪");
                return;
            }
            doms = Array.from(doms);
            doms.forEach((item, index) => {
                this.num = "2.6";
                let title = item.children[0].getAttribute("title");
                let connector_id = title.slice(30);
                let myCanvas = document
                    .querySelector("#captureId" + index)
                    .getElementsByTagName("canvas");
                let src = myCanvas[0].toDataURL("image/png");
                let url = this.onCreateCanvas(src, connector_id);
                this.stationCanvas.push(url);
                const Obj = {
                    url: title,
                    src: url,
                };
                this.list.forEach(item1 => {
                    if (item1.url === Obj.url) {
                        item1.imgSrc = Obj.src;
                    }
                });
                this.num = "5.4";
                if (this.stationCanvas.length === this.list.length) {
                    const zip = new JSZip();
                    const cache = {};
                    const arr = this.list;
                    this.num = "6.5";
                    arr.forEach(item => {
                        // 设置生成的文件名
                        const fileName = item.connName + "-" + item.fileName;
                        // 文件名加文件流加格式
                        zip.file(`${fileName}.png`, item.imgSrc.substring(22), {
                            base64: true,
                        });
                        cache[fileName] = item.imgSrc;
                    });
                    let that = this;
                    zip.generateAsync({ type: "blob" }, function updateCallback(metadata) {
                        console.log(metadata);
                        that.num = metadata.percent.toFixed(1);
                    })
                        .then(content => {
                            console.log(content);
                            FileSaver.saveAs(content, that.siteName + ".zip"); //这里设置压缩包的名称
                        })
                        .catch(error => {
                            // console.log(error);
                            util.ShowTip("压缩图片失败：" + error, 3);
                        });
                }
            });
        },
        /*合并图片*/
        onCreateCanvas(src, connector_id) {
            let img = new Image();
            img.src = src; // canvas画布导出图片
            let imgHeight = img.naturalHeight;
            let imgWidth = img.naturalWidth;
            //构建画布;
            const canvas = document.createElement("canvas");
            let img2 = this.$refs.bg;
            let img2Height = img2.naturalHeight;
            let img2Width = img2.naturalWidth;
            canvas.width = img2Width;
            canvas.height = img2Height;
            let context = canvas.getContext("2d");
            context.drawImage(img2, 0, 0, img2Width, img2Height); // 加入图片2
            context.drawImage(img, 0, 0, imgWidth, imgHeight, 820, 420, 500, 500);
            context.fillStyle = "black"; // 设置文字的填充颜色
            context.font = "normal 35px normal"; // 设置文字的填充样式
            // context.textAlign = "center";
            // context.fillText(connector_id, img2Width / 1.3, 470 + imgHeight);
            let ll = 500 / 2 + 820 - connector_id.pxWidth(context.font) / 2;
            context.fillText(connector_id, ll, 970);
            var url = canvas.toDataURL("image/png");
            return url;
        },
        cancal() {
            this.$emit("cancal");
        },
    },
};
</script>
<style scoped>
.packageImages {
    width: 100%;
    height: 20rem;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.circular {
    width: 10rem;
    height: 10rem;
    /* display: flex;
    justify-content: center;
    align-items: center; */
    position: relative;
}
.text {
    width: 10rem;
    height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
    color: #ffffff;
    margin-top: -0.3rem;
    margin-left: -0.3rem;
    /* background-color: red; */
}
.download {
    width: 8rem;
    height: 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0rem;
    left: 0;
    right: 0;
    /* background-color: red; */
    border-radius: 50%;
    position: relative;
    background: linear-gradient(120deg, #34e0f0 0%, #b400ff 100%);
    opacity: 0.8;
    animation: rotateMain 4s linear infinite;
}
.download ::before {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, #35a0f0 0%, #b233f0 100%);
    opacity: 0.8;
    box-shadow: 5px 5px 90px rgba(10, 102, 255, 0.5);
    border-radius: 35%;
    animation: rotateMain 4s linear 2s infinite;
}

.download ::after {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(60deg, #33580f 0%, #b7ee6d 100%);
    opacity: 0.8;
    box-shadow: 5px 5px 60px rgba(20, 102, 255, 0.3);
    border-radius: 35%;
    animation: rotateMain 4s linear 4s infinite;
    z-index: -1;
}

@keyframes rotateMain {
    25% {
        transform: rotateZ(90deg);
        border-radius: 25%;
    }
    37.5% {
        transform: rotateZ(135deg);
        border-radius: 37.5%;
    }
    50% {
        transform: rotateZ(180deg);
        border-radius: 50%;
    }
    62.5% {
        transform: rotateZ(225deg);
        border-radius: 62.5%;
    }
    75% {
        transform: rotateZ(270deg);
        border-radius: 75%;
    }
    87.5% {
        transform: rotateZ(315deg);
        border-radius: 87.5%;
    }
    100% {
        transform: rotateZ(360deg);
        border-radius: 35%;
    }
}
.prompt {
    margin-top: 1.5rem;
    animation: shake-baidu 1.5s ease 0s infinite;
}
@keyframes shake-baidu {
    from {
        transform: rotate(0deg);
    }
    4% {
        transform: rotate(5deg);
    }
    12.5% {
        transform: rotate(-5deg);
    }
    21% {
        transform: rotate(5deg);
    }
    29% {
        transform: rotate(-5deg);
    }
    37.5% {
        transform: rotate(5deg);
    }
    46% {
        transform: rotate(-5deg);
    }
    50%,
    to {
        transform: rotate(0deg);
    }
}
</style>
